import { ComponentPropsWithoutRef } from 'react';
import type { StorefrontTag } from '@/api/menu-list/storefront-menu-snapshot.types';
import { AnyIconName, Icon } from '@/shared/ui/icon';
import { TagsT } from '@/shared/ui/tags/types';

/**
 * Maps storefront tag definitions of an item into the `TagsT` shape consumed by
 * the `Tags`/`Badge` components. Visual data (label, icon, color) comes from the
 * tag definition itself; placement/appearance is controlled separately via the
 * website config. Returns undefined when there are no tags so the UI renders no
 * empty placeholder.
 */
export const buildItemTags = (tags?: StorefrontTag[] | null): TagsT | undefined => {
    if (!tags?.length) {
        return undefined;
    }

    return [...tags]
        .sort((a, b) => a.sortIndex - b.sortIndex)
        .map((tag) => ({
            label: tag.name,
            variant: tag.backgroundColor ? ('customColor' as const) : undefined,
            customColor: tag.backgroundColor ?? undefined,
            icon: tag.icon
                ? (props: ComponentPropsWithoutRef<'svg'>) => (
                      <Icon name={tag.icon as AnyIconName} {...props} />
                  )
                : undefined,
        }));
};
